import { useState, useEffect } from 'react';

import styled from 'styled-components';
import Lottie from 'lottie-react';

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';

import MembershipPreferenceView from './MembershipPreferenceView';
import { computeMembershipPreference } from './membershipPreferenceCompute';

import LoadingAnimation from '../../../Animation/NewLoading.json';

export default function MembershipPreferenceBox(props) {
  const {
    calcDateText,
    startDate,
    endDate,
    allMembers,
    salesData,
    isLoadingAllMember,
    isOpenPartnerGymSales,
    isMembershipPreferenceLoading,
    setIsMembershipPreferenceLoading,
  } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const [rankings, setRankings] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [topCards, setTopCards] = useState(null);
  const [avgReRegRate, setAvgReRegRate] = useState(0);

  // 회원권 선호도 데이터 가공 (가입 회원 = 산정기간 내 등록한 신규+재등록 회원) //
  useEffect(() => {
    if (isLoadingAllMember) return;

    const result = computeMembershipPreference({ allMembers, salesData, startDate, endDate });

    setRankings(result.rankings);
    setTotalCount(result.totalCount);
    setTotalRevenue(result.totalRevenue);
    setTopCards(result.topCards);
    setAvgReRegRate(result.avgReRegRate);
    setIsMembershipPreferenceLoading(false);
  }, [allMembers, salesData, startDate, endDate, isLoadingAllMember]);

  return (
    <TopLevelWrapper $isDark={isDark}>
      {
        isMembershipPreferenceLoading ?
          <AnimationBox>
            <LottieWrapper>
              <Lottie animationData={LoadingAnimation} loop={true} />
            </LottieWrapper>
          </AnimationBox>
          :
          isOpenPartnerGymSales ?
            <ContentWrapper>
              <TitleRow>
                <Text fontFamily='NotoSansKR-Bold' fontSize={20} color={theme.text}>
                  {calcDateText()}
                </Text>
                <Text fontFamily='NotoSansKR-Bold' fontSize={20} color={theme.text}>
                  {t('statistics.membershipPreference.title')}
                </Text>
              </TitleRow>
              <MembershipPreferenceView
                rankings={rankings}
                totalCount={totalCount}
                totalRevenue={totalRevenue}
                topCards={topCards}
                avgReRegRate={avgReRegRate} />
            </ContentWrapper>
            :
            <NotOpenWrapper>
              <Text fontFamily='NotoSansKR-Bold' fontSize={15} color={theme.subText}>{t('statistics.partnerGymPrivate')}</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={15} color={theme.subText}>{t('statistics.partnerGymPrivateDesc')}</Text>
            </NotOpenWrapper>
      }
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: flex-start;
  justify-content: center;

  margin: 39.5px 0;
  padding: 20px 40px;

  width: 100%;
  max-width: 960px;

  gap: 10px;

  border-radius: 20px;
  background-color: ${props => props.theme.subBackground};
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  align-items: flex-start;

  width: 100%;

  gap: 20px;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;

  width: 100%;
`;

const AnimationBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 300px;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 160px;
  height: 160px;
`;

const NotOpenWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  padding: 40px 0;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0;
  cursor: default;
`;
